import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTeamColors } from 'hooks/useTeamColors';
import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from 'firebase.js';
import {
  OverlayContainer,
  ModalContent,
  ModalTitle,
  ModalText,
  ModalButtonContainer,
  ModalButton,
  MaybeLaterButton,
} from './style';

export const PushNotificationPermissionModal = ({
  show,
  onAllow,
  onMaybeLater,
  dismissCount = 0,
}) => {
  const siteName = useSelector(
    (state) => state.configuration?.data?.site_name || ''
  );
  const { mainColor } = useTeamColors();
  const analytics = getAnalyticsInstance();

  const handleAllow = () => {
    logEvent(analytics, 'push_permission_button_clicked', {
      action: 'allow',
      dismiss_count: dismissCount,
      timestamp: new Date().toISOString(),
    });
    onAllow();
  };

  const handleMaybeLater = () => {
    logEvent(analytics, 'push_permission_button_clicked', {
      action: 'maybe_later',
      dismiss_count: dismissCount,
      timestamp: new Date().toISOString(),
    });
    onMaybeLater();
  };

  return (
    <OverlayContainer $show={show}>
      <ModalContent $borderColor={mainColor} $show={show}>
        <ModalTitle>Stay Updated with {siteName}!</ModalTitle>
        <ModalText>Get notified about your favorite teams:</ModalText>
        <ModalText style={{ marginTop: '10px', fontSize: '14px' }}>
          • Game reminders 1 hour before start time
          <br />
          • Score updates and game outcome
          <br />• Event news and game summary
        </ModalText>
        {/* TODO: Add notification settings/preferences page where users can manage their notification preferences */}
        <ModalButtonContainer>
          <ModalButton $color={mainColor} onClick={handleAllow}>
            Enable Notifications
          </ModalButton>
          <MaybeLaterButton onClick={handleMaybeLater}>
            Maybe Later
          </MaybeLaterButton>
        </ModalButtonContainer>
      </ModalContent>
    </OverlayContainer>
  );
};

PushNotificationPermissionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onAllow: PropTypes.func.isRequired,
  onMaybeLater: PropTypes.func.isRequired,
  dismissCount: PropTypes.number,
};

export default PushNotificationPermissionModal;
